import { makeStyles, createStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    paper: {
      minWidth: "400px",
    },
    title: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    cancelButton: {
      color: theme.palette.error.main,
    },
    rowWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    greenFont: {
      fontSize: "14px",
      fontWeight: "400",
      color: theme.palette.success.main,
      marginBottom: "10px"
    },

    redFont: {
      fontSize: "14px",
      fontWeight: "400",
      color: theme.palette.error.main,
    },

    blueFont: {
      fontSize: "14px",
      fontWeight: "400",
      color: "#0000FF",
    },

    grayFont: {
      color: "#9A9A9A",
      fontSize: "14px",
      textAlign: "left",
    },

  })
)

export default useStyles
